import { render, staticRenderFns } from "./StudentFeeSelectionBox.vue?vue&type=template&id=14d48c03"
import script from "./StudentFeeSelectionBox.vue?vue&type=script&lang=js"
export * from "./StudentFeeSelectionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports